import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Faq.module.css';

const FAQ_ITEMS = [
  {
    title: 'Можно ли играть с пиратки?',
    body: (
      <>
        Нет, только официальная лицензия Hytale. Купить игру можно на{' '}
        <a href="https://hytale.com/" target="_blank" rel="noreferrer" className={styles.link}>
          официальном сайте hytale.com
        </a>
        .
      </>
    ),
  },
  {
    title: 'Как начать играть на InterWorld?',
    body: (
      <>
        Для начала необходимо <span className={styles.accent}>приобрести</span> и установить
        лицензионный Hytale, а затем подключиться к серверу{' '}
        <code className={styles.code}>play.interworld.fun</code>.
      </>
    ),
  },
  {
    title: 'Что делать новичку на сервере?',
    body: (
      <>
        Для новых игроков доступен квест{' '}
        <span className={styles.accent}>«Путь новичка»</span> — он поможет освоить основные
        механики и понять принцип игры на проекте.
      </>
    ),
  },
  {
    title: 'Где найти гайды и вики?',
    body: (
      <>
        Подробные гайды, описания механик и профессий собраны в официальной{' '}
        <Link to="/wiki" className={styles.link}>Вики проекта</Link> — это удобная база
        знаний для игроков.
      </>
    ),
  },
  {
    title: 'Где найти правила сервера?',
    body: (
      <>
        Все правила и важные объявления публикуются в нашем{' '}
        <a
          href="https://t.me/hytale_interworld"
          target="_blank"
          rel="noreferrer"
          className={styles.link}
        >
          Telegram‑канале
        </a>
        .
      </>
    ),
  },
  {
    title: 'Не удаётся войти на сервер?',
    body: (
      <>
        При проблемах со входом напиши в техническую поддержку в Telegram —{' '}
        <a
          href="https://t.me/interworld_support_bot"
          target="_blank"
          rel="noreferrer"
          className={styles.link}
        >
          @interworld_support_bot
        </a>
        .
      </>
    ),
  },
];

const Faq = () => (
  <section className={styles.section}>
    <div className={styles.wrap}>
      <div className={styles.head}>
        <h2 className={styles.title}>Ответы на частые вопросы</h2>
        <Link to="/wiki" className={styles.helpLink}>
          Открыть справочный раздел
        </Link>
      </div>

      <div className={styles.grid}>
        {FAQ_ITEMS.map((item) => (
          <div key={item.title} className={styles.card}>
            <h3 className={styles.cardTitle}>{item.title}</h3>
            <p className={styles.cardBody}>{item.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Faq;
